import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Link, Text, Icon, Box, Section } from "@quarkly/widgets";
import { BsDot } from "react-icons/bs";
const defaultProps = {
	"padding": "70px 0 70px 0",
	"sm-padding": "40px 0 40px 0",
	"background": "#fff",
	"quarkly-title": "Footer"
};
const overrides = {
	"link": {
		"kind": "Link",
		"props": {
			"href": "/",
			"color": "--darkL1",
			"text-decoration-line": "initial",
			"font": "normal 600 28px/1.2 --fontFamily-sans",
			"display": "block",
			"margin": "0px 0 35px 0px",
			"sm-margin": "0px 0 5px 0px",
			"text-align": "center",
			"hover-color": "--primary",
			"children": "FitZone"
		}
	},
	"box": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"margin": "0px 0px 50px 0px",
			"md-flex-wrap": "wrap",
			"md-margin": "0px 0px 35px 0px",
			"align-items": "center",
			"justify-content": "center"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"color": "--darkL2",
			"margin": "0px 6px 0px 0px",
			"md-margin": "0px 6px 0px 6px",
			"href": "/index",
			"font": "normal 500 16px/1.5 --fontFamily-sans",
			"text-decoration-line": "initial",
			"border-color": "--color-darkL2",
			"letter-spacing": "1px",
			"hover-color": "--primary",
			"padding": "6px 12px 6px 12px",
			"text-transform": "uppercase",
			"children": "Ana sayfa"
		}
	},
	"icon": {
		"kind": "Icon",
		"props": {
			"category": "bs",
			"icon": BsDot,
			"size": "24px",
			"color": "#b2b8be"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"margin": "0px 6px 0px 6px",
			"href": "/about",
			"font": "normal 500 16px/1.5 --fontFamily-sans",
			"text-decoration-line": "initial",
			"color": "--darkL2",
			"border-color": "--color-darkL2",
			"letter-spacing": "1px",
			"hover-color": "--primary",
			"padding": "6px 12px 6px 12px",
			"text-transform": "uppercase",
			"children": "Hakkımızda"
		}
	},
	"icon1": {
		"kind": "Icon",
		"props": {
			"category": "bs",
			"icon": BsDot,
			"size": "24px",
			"color": "#b2b8be"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"margin": "0px 6px 0px 6px",
			"href": "/service",
			"font": "normal 500 16px/1.5 --fontFamily-sans",
			"text-decoration-line": "initial",
			"color": "--darkL2",
			"border-color": "--color-darkL2",
			"letter-spacing": "1px",
			"hover-color": "--primary",
			"padding": "6px 12px 6px 12px",
			"text-transform": "uppercase",
			"children": "Güzel fotoğraflar"
		}
	},
	"icon2": {
		"kind": "Icon",
		"props": {
			"category": "bs",
			"icon": BsDot,
			"size": "24px",
			"color": "#b2b8be"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"margin": "0px 6px 0px 6px",
			"href": "/contact",
			"font": "normal 500 16px/1.5 --fontFamily-sans",
			"text-decoration-line": "initial",
			"color": "--darkL2",
			"border-color": "--color-darkL2",
			"letter-spacing": "1px",
			"hover-color": "--primary",
			"padding": "6px 12px 6px 12px",
			"text-transform": "uppercase",
			"children": "İletişim"
		}
	},
	"link5": {
		"kind": "Link",
		"props": {
			"href": "/politika",
			"color": "--primary",
			"text-align": "center",
			"font": "normal 300 16px/1.5 --fontFamily-sansTrebuchet",
			"text-decoration-line": "initial",
			"display": "inline-block",
			"hover-text-decoration-line": "underline",
			"children": "Politika Konfüçyüs"
		}
	}
};

const Footer = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" font="normal 300 16px/1.5 --fontFamily-sansTrebuchet" align-items="center" justify-content="center" />
		<Link {...override("link")} />
		<Box {...override("box")}>
			<Link {...override("link1")} />
			<Icon {...override("icon")} />
			<Link {...override("link2")} />
			<Icon {...override("icon1")} />
			<Link {...override("link3")} />
			<Icon {...override("icon2")} />
			<Link {...override("link4")} />
		</Box>
		<Link {...override("link5")} />
		{children}
	</Section>;
};

Object.assign(Footer, { ...Section,
	defaultProps,
	overrides
});
export default Footer;